/** @jsxImportSource @emotion/react */
import React from 'react';
import TextBlock from 'component/common/block/text-block';
import IconBlock from 'component/common/block/icon-block';
import { IBlock, TIcon } from '@datatype/type';
import BoxBlock from '@component/common/block/box-block';
import { useClicker } from '@hook/common/useEvent';

interface IProps {
  icon: TIcon;
  text: string;
  arrangement?: 'icon-text' | 'text-icon';
  design: Pick<IBlock['design'], 'box' | 'text' | 'icon'>;
  click?: IBlock['click'];
}

const IconTextBlock: React.FC<IProps> = ({ icon, text, arrangement = 'icon-text', design, click }) => {
  const clicker = useClicker(click?.handler, click?.delay, click?.mode);

  return (
    <>
      <BoxBlock design={{ box: { ...design.box } }} onClick={clicker}>
        {arrangement === 'icon-text' ? (
          <>
            <IconBlock
              icon={icon}
              design={{ icon: { size: design.icon?.size, color: design.icon?.color, kind: design.icon?.kind } }}
            />
            <TextBlock text={text} design={{ text: design.text }} />
          </>
        ) : (
          <>
            <TextBlock text={text} design={{ text: design.text }} />
            <IconBlock
              icon={icon}
              design={{ icon: { size: design.icon?.size, color: design.icon?.color, kind: design.icon?.kind } }}
            />
          </>
        )}
      </BoxBlock>
    </>
  );
};

export default IconTextBlock;
